import {
  ACCOUNT_GET_INFO,
  ACCOUNT_UPLOAD_PROFILE_IMAGE,
  ACCOUNT_REMOVE_PROFILE_IMAGE,
  ACCOUNT_UPDATE_PASSWORD,
  ACCOUNT_UPDATE_PASSWORD_MAIL,
  ACCOUNT_UPDATE_INFO,
  ACCOUNT_UPDATE_UNICOL,
  ACCOUNT_CLOSE,
  ACCOUNT_REQUEST,
  ACCOUNT_SUCCESS,
  ACCOUNT_FAILURE,
  ACCOUNT_REVIEW_CREATE,
  ACCOUNT_REVIEW_GET_LIST,
  ACCOUNT_REVIEW_VOTE,
  ACCOUNT_REVIEW_UPDATE,
  ACCOUNT_REVIEW_DELETE,
  ACCOUNT_REVIEW_REQUEST,
  ACCOUNT_REVIEW_SUCCESS,
  ACCOUNT_REVIEW_FAILURE,
  ACCOUNT_ORDER_GET_LIST,
  ACCOUNT_ORDER_CANCEL,
  ACCOUNT_ORDER_REQUEST_RETURN,
  //ACCOUNT_ORDER_CANCEL_RETURN,
  //ACCOUNT_ORDER_GET,
  ACCOUNT_ORDER_REQUEST,
  ACCOUNT_ORDER_SUCCESS,
  ACCOUNT_ORDER_FAILURE,
  ACCOUNT_RETURN_GET_LIST,
  ACCOUNT_RETURN_REQUEST,
  ACCOUNT_RETURN_SUCCESS,
  ACCOUNT_RETURN_FAILURE,
  ACCOUNT_ORDER_DELIVERY_DETAIL_GET,
  ACCOUNT_ORDER_DELIVERY_DETAIL_REQUEST,
  ACCOUNT_ORDER_DELIVERY_DETAIL_SUCCESS,
  ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE,
  ACCOUNT_DISCOUNT_GET_LIST,
  ACCOUNT_DISCOUNT_REQUEST,
  ACCOUNT_DISCOUNT_SUCCESS,
  ACCOUNT_DISCOUNT_FAILURE
} from '@/store/types'

import axios from '@/store/axios'

/* TODO: @stan, 
    Refactor keyMapper values as global constant and 
    methods for converting from and to
  */
const keyMapper = {
  loginId: 'username',
  loginNm: 'name',
  memberId: 'id'
}

// Set current selected library as default library
const state = {
  account: null,
  isLoading: false,
  error: null,
  reviews: null,
  isReviewLoading: false,
  reviewMeta: {},
  orders: null,
  isOrderLoading: false,
  orderMeta: {},
  returns: null,
  isReturnLoading: false,
  returnMeta: {},
  delivery: null,
  isDeliveryLoading: false,
  discounts: null,
  discountsCount: 0,
  isDiscountsLoading: false
}

const getters = {
  isAccountLoading: (state) => state.isLoading,
  getAccount: (state) => state.account,
  isAccountReviewLoading: (state) => state.isReviewLoading,
  getAccountReviews: (state) => state.reviews,
  getAccountReviewTotalCount: (state) =>
    state.reviewMeta.totalCount || (state.reviews ? state.reviews.length : 0),

  isAccountReturnLoading: (state) => state.isReturnLoading,
  getAccountReturns: (state) => state.returns,
  getAccountReturnTotalCount: (state) =>
    state.returnMeta.totalCount || (state.returns ? state.returns.length : 0),

  isAccountOrderLoading: (state) => state.isOrderLoading,
  getAccountOrders: (state) => state.orders,
  getAccountOrderTotalCount: (state) =>
    state.orderMeta.totalCount || (state.orders ? state.orders.length : 0),
  isAccountOrderDeliveryLoading: (state) => state.isDeliveryLoading,
  getAccountOrderDelivery: (state) => state.delivery,

  isAccountDiscountsLoading: (state) => state.isDiscountsLoading,
  getAccountDiscounts: (state) => state.discounts,
  getAccountDiscountsCount: (state) => state.discountsCount
}

const actions = {
  [ACCOUNT_GET_INFO]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .get(`/member/authenticate/profile`)
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, { account: resp.data.result.profile })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_UPLOAD_PROFILE_IMAGE]: ({ commit }, url) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      const formattedUrl = url.split('?')[0]

      const payload = {
        profile: {
          profileImage: {
            profileThumbUrl: formattedUrl
          }
        }
      }

      axios
        .put('/member/profile/image', payload)
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {
            imageUrl: formattedUrl
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REMOVE_PROFILE_IMAGE]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .delete('/member/profile/image')
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, { imageUrl: 'removed' })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_UPDATE_PASSWORD]: ({ commit }, newPassword) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .put('/member/authenticate/password', {
          profile: {
            loginPwd: btoa(newPassword)
          }
        })
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },

  // Reset password from mail link
  [ACCOUNT_UPDATE_PASSWORD_MAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .put('/auth/update-pwd', {
          authentication: {
            updateHash: payload.updateHash,
            loginPwd: btoa(payload.newPassword)
          }
        })
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },

  [ACCOUNT_UPDATE_INFO]: ({ commit }, updatedProfile) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)
      axios
        .put('/member/authenticate/profile', updatedProfile)
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_UPDATE_UNICOL]: ({ commit }, { unicolCode, division }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)
      axios
        .put('/member/unicol', {
          profile: { groups: { unicolCd: unicolCode, division: division } }
        })
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_CLOSE]: ({ commit }, reasons) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .delete('/member/authenticate/withdrawal', { data: reasons })
        .then((resp) => {
          commit(ACCOUNT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REVIEW_GET_LIST]: ({ commit }, { page }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REVIEW_REQUEST)

      axios
        .get('/mypage/review/list', {
          params: {
            pageNo: page
          }
        })
        .then((resp) => {
          commit(ACCOUNT_REVIEW_SUCCESS, {
            reviews: resp.data.result.reviewList,
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REVIEW_CREATE]: ({ commit }, review) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REVIEW_REQUEST)

      axios
        .post(`/book/review`, { review })
        .then((resp) => {
          commit(ACCOUNT_REVIEW_SUCCESS, {
            review: resp.data.result.bookReview
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REVIEW_UPDATE]: ({ commit }, review) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REVIEW_REQUEST)

      axios
        .put(`/mypage/review`, { review })
        .then((resp) => {
          commit(ACCOUNT_REVIEW_SUCCESS, { review })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REVIEW_DELETE]: ({ commit }, review) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REVIEW_REQUEST)

      axios
        .delete(`/mypage/review`, { data: { review } })
        .then((resp) => {
          commit(ACCOUNT_REVIEW_SUCCESS, { deleted: review })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_ORDER_GET_LIST]: ({ commit }, { page, countPerPage }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_ORDER_REQUEST)

      axios
        .get(
          `/mypage/purchase/list?searchTp=CP&pageNo=${page || 1}&pageRow=${
            countPerPage || 10
          }`
        )
        .then((resp) => {
          commit(ACCOUNT_ORDER_SUCCESS, {
            orders: resp.data.result.purchaseList,
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          alert(
            '[다른 기기에서 접속되어 로그아웃되었습니다. 이용을 원하시면 다시 로그인 해주세요.]'
          )
          localStorage.removeItem('token')
          location.href = '/'
          commit(ACCOUNT_ORDER_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_ORDER_CANCEL]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_ORDER_REQUEST)

      axios
        .put(`/purchase/state/${id}?orderStateTp=CC`)
        .then((resp) => {
          commit(ACCOUNT_ORDER_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_ORDER_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_ORDER_REQUEST_RETURN]: ({ commit }, { id, purchase }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_ORDER_REQUEST)

      axios
        .put(`/purchase/return/${id}`, { purchase })
        .then((resp) => {
          commit(ACCOUNT_ORDER_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_ORDER_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_RETURN_GET_LIST]: ({ commit }, { page, countPerPage }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_RETURN_REQUEST)

      axios
        .get(
          `/mypage/purchase/list?searchTp=CC&pageNo=${page || 1}&pageRow=${
            countPerPage || 10
          }`
        )
        .then((resp) => {
          commit(ACCOUNT_RETURN_SUCCESS, {
            returns: resp.data.result.purchaseList,
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_RETURN_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_ORDER_DELIVERY_DETAIL_GET]: (
    { commit },
    { carrier, trackingNo }
  ) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_ORDER_DELIVERY_DETAIL_REQUEST)

      axios
        .get(`/delivery/carriers/${carrier}/tracking/${trackingNo}`)
        .then((resp) => {
          if (
            resp.data.result &&
            resp.data.result.delivery &&
            resp.data.result.delivery.message ===
              '운송장 정보를 찾을 수 없습니다.'
          ) {
            commit(ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE, { response: resp })
            reject({ response: resp })
          } else {
            commit(ACCOUNT_ORDER_DELIVERY_DETAIL_SUCCESS, {
              delivery: resp.data.result.delivery
            })
            resolve(resp)
          }
        })
        .catch((err) => {
          commit(ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_REVIEW_VOTE]: ({ commit }, { reviewId, bookId, evalTp }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REVIEW_REQUEST)

      axios
        .put(
          `/book/review/${bookId}/evaluate?reviewSeq=${reviewId}&evalTp=${evalTp}`
        )
        .then((resp) => {
          commit(ACCOUNT_REVIEW_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_REVIEW_FAILURE, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_DISCOUNT_GET_LIST]: ({ commit }, sort) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_DISCOUNT_REQUEST)

      axios
        .get(`/discount/coupon/list?sort=${sort}`)
        .then((resp) => {
          commit(ACCOUNT_DISCOUNT_SUCCESS, {
            discounts: resp.data.result.list,
            count: resp.data.result.totalCount
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(ACCOUNT_DISCOUNT_FAILURE)
          reject(err)
        })
    })
  }
}

const mutations = {
  [ACCOUNT_REQUEST]: (state) => {
    state.isLoading = true
  },
  [ACCOUNT_SUCCESS]: (state, { account, imageUrl }) => {
    state.isLoading = false

    if (account) {
      Object.keys(account).map((key) => {
        if (keyMapper[key]) {
          account[keyMapper[key]] = account[key]
        }
      })

      state.account = account
    }

    if (imageUrl) {
      state.account.profileImage.profileThumbUrl =
        imageUrl === 'removed' ? null : imageUrl
    }
  },
  [ACCOUNT_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [ACCOUNT_REVIEW_REQUEST]: (state) => {
    state.isReviewLoading = true
  },
  [ACCOUNT_REVIEW_SUCCESS]: (state, { reviews, meta, deleted, review }) => {
    state.isReviewLoading = false

    if (reviews) {
      state.reviews = reviews
    }

    if (meta) {
      state.reviewMeta = meta
    }

    if (deleted) {
      state.reviews = state.reviews.filter((r) => r.bookCd !== deleted.bookCd)
    }

    if (review) {
      if (!state.reviews || !state.reviews.length) {
        state.reviews = [review]
      } else {
        const updated = state.reviews.find((r) => r.bookCd === review.bookCd)
        const formatted = { ...updated, ...review }
        state.reviews = [
          formatted,
          ...state.reviews.filter((r) => r.bookCd !== review.bookCd)
        ]
      }
    }
  },
  [ACCOUNT_REVIEW_FAILURE]: (state, err) => {
    state.isReviewLoading = false

    if (err) {
      state.error = err
    }
  },
  [ACCOUNT_ORDER_REQUEST]: (state) => {
    state.isOrderLoading = true
  },
  [ACCOUNT_ORDER_SUCCESS]: (state, { orders, meta }) => {
    state.isOrderLoading = false

    if (orders) {
      state.orders = orders
    }

    if (meta) {
      state.orderMeta = meta
    }
  },
  [ACCOUNT_ORDER_FAILURE]: (state, err) => {
    state.isOrderLoading = false

    state.error = err
  },
  [ACCOUNT_RETURN_REQUEST]: (state) => {
    state.isReturnLoading = true
  },
  [ACCOUNT_RETURN_SUCCESS]: (state, { returns, meta }) => {
    state.isReturnLoading = false

    if (returns) state.returns = returns

    if (meta) {
      state.returnMeta = meta
    }
  },
  [ACCOUNT_RETURN_FAILURE]: (state, err) => {
    state.isReturnLoading = false

    state.error = err
  },
  [ACCOUNT_ORDER_DELIVERY_DETAIL_REQUEST]: (state) => {
    state.isDeliveryLoading = true
  },
  [ACCOUNT_ORDER_DELIVERY_DETAIL_SUCCESS]: (state, { delivery }) => {
    state.isDeliveryLoading = false

    if (delivery) {
      state.delivery = delivery
    }
  },
  [ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE]: (state, err) => {
    state.isDeliveryLoading = false

    state.error = err
  },
  [ACCOUNT_DISCOUNT_REQUEST]: (state) => {
    state.isDiscountsLoading = true
  },
  [ACCOUNT_DISCOUNT_SUCCESS]: (state, { count, discounts }) => {
    state.isDiscountsLoading = false
    state.discountsCount = 0
    if (discounts) {
      state.discounts = discounts
    }
    if (count) {
      state.discountsCount = count
    }
  },
  [ACCOUNT_DISCOUNT_FAILURE]: (state, err) => {
    state.isDiscountsLoading = false

    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
